import imageIcon from "../../../assets/icons/image.png";

import styles from "./Image.module.css";

function DefaultImage() {
	return (
		<div className={styles.defaultImage}>
			<img
				src={imageIcon}
				alt="sem imagem"
			/>
		</div>
	);
}

export default DefaultImage;
